import React, { PureComponent } from 'react';
import Locale from '@active/react-utils/i18n/Locale';
import BitMapImg from './bitmap.svg';
import { handleKeyboardEvent } from '../../../../../../../../../../shared/utils/commonUtils';

class BitMap extends PureComponent {
  state = {
    isShowBitMap: false,
  }

  toggleTips = () => {
    const { isShowBitMap } = this.state;
    this.setState({
      isShowBitMap: !isShowBitMap,
    });
  }

  render() {
    const { isShowBitMap } = this.state;

    return (
      <div className="bitmap">
        <span tabIndex={0} role="button" aria-labelledby='payment-echeck-hint' aria-expanded={this.state.isShowBitMap} onKeyDown={handleKeyboardEvent(this.toggleTips, [ 'Enter', ' ' ])} className="bitmap--text" onClick={this.toggleTips}>
          <span className={`ic-triangle-${isShowBitMap ? 'down' : 'right'}`} />
          <span id="payment-echeck-hint">
            <Locale id="checkout.lib.components.payment.echeck.hint" />
          </span>
        </span>
        {
          isShowBitMap && <img src={BitMapImg} alt="map" />
        }
      </div>
    );
  }
}

export default BitMap;
